import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import * as specificationApi from "../../api/equipmentApi/specificationApi";
import {useGetQuery} from "../../hooks/useQueryHooks";
import {ResponseList} from "../../models/clientModels/interfaces/Response";

import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {
  EQSpecification,
  initialReliabilityParams,
} from "../../models/serverModels/equipment/EQSpecification";
import {PaginationContainer} from "../../styledComponents/StyledPagination";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));

const ReliabilityList = () => {
  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);

  const {
    data: reliabilityList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQSpecification>>({
    key: ["reliabilityList", {...initialReliabilityParams, token: tokenState, page}],
    api: () =>
      specificationApi.reliabilityList({...initialReliabilityParams, token: tokenState, page}),
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <ListContainer>
      <SubTitle subTitle="설비 신뢰도 관리" />

      <StyledTableContainer>
        <Table>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">설비번호</TableCell>
              <TableCell align="center">설비명</TableCell>
              <TableCell align="center">설비수명(hr) (MTTF)</TableCell>
              <TableCell align="center">가동시간(hr)</TableCell>
              <TableCell align="center">잔여시간(hr)</TableCell>
              <TableCell align="center">고장횟수</TableCell>
              <TableCell align="center">총 수리시간(hr)</TableCell>
              <TableCell align="center">MTTR</TableCell>
              <TableCell align="center">평균고장간격(hr) (MTBF)</TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={9} />
            ) : (
              reliabilityList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    <Link to={`/Equipment/Detail/${item.uid}`}> {item.identifyNumber}</Link>
                  </TableCell>
                  <TableCell align="center">{item.name}</TableCell>
                  <TableCell align="center">{item.lifeTime}</TableCell>
                  <TableCell align="center">{item.workHours}</TableCell>
                  <TableCell align="center">{item.lifeTime - item.workHours}</TableCell>
                  <TableCell align="center">{item.totalOrderCount}</TableCell>
                  <TableCell align="center">{item.totalRepairHours}</TableCell>
                  <TableCell align="center">{item.mttr}</TableCell>
                  <TableCell align="center">{item.mtbf}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={reliabilityList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default ReliabilityList;
